/**
 * Test IDs for QA automation.
 */
export const testIds = {
  mileageBlockTrips: "trip-block-mileage",
  mileageBlockOrders: "order-block-mileage",
  mileageBlockRouteMilesInput: "mileage-block-route-miles-input",
  mileageBlockLoadedMilesInput: "mileage-block-loaded-miles-input",
  mileageBlockEmptyMilesInput: "mileage-block-empty-miles-input",
  mileageBlockActualTripMilesInput: "mileage-block-actual-trip-miles-input",
} as const;
